import {
    useEffect,
    useState,
    useRef
} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTE_EDIT_BUILDING, ROUTE_REGION_AND_BUILDING_DATA } from '../Routes/Routes';
import GetFetch from '../../hooks/GetFetch';
import PutPostPatchFetch from '../../hooks/PutPostPatchFetch.js';
import { usStates } from '../../util/StateAbbreviations';
import FormConfig from '../../FormConfig/FormConfig';
import { physicalAddressSplitter } from '../../util/_helpers';
import { buttonTypeNames, formGroupNames } from '../Shared/shared';
import { showNotification } from '../../util/_helpers';
import './../../sass/_utilities.scss';

 
const BuildingsUpdate = () => {
    const { state: { selectedRowData } } = useLocation();
    useEffect(() => { getRegions() }, [])

    console.log("rowdata:", selectedRowData)

    const updatedBuildingObject = Object.fromEntries(
        Object.entries({
            ...selectedRowData,
            ...physicalAddressSplitter(selectedRowData.address)
        })
    );

    const [formData, setFormData] = useState(updatedBuildingObject);
    const [regions, setRegions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isNotDirty, setIsNotDirty] = useState(true);

    const navigate = useNavigate();
    const { title } = ROUTE_EDIT_BUILDING;
    let newFormData;

    const validationGroupRef = useRef(null);
    const initialFormDataRef = useRef(updatedBuildingObject);

    const isFormDirty = (current, initial) => {
        console.log("Is Form Dirty:", JSON.stringify(current) !== JSON.stringify(initial))
        return JSON.stringify(current) === JSON.stringify(initial);
    }
    isFormDirty(newFormData, initialFormDataRef.current)

    const getRegions = async () => {
        const { Success, Message, Errors } = await GetFetch('/v1/Region');
        if (Success) setRegions(Message.map(({ RegionNumber }) => RegionNumber));
        if (Errors.length > 0) console.error(Errors);
    };
    const handle9DigitZips = (value) => {
        let retValue = value;
        if (value !== undefined) {
            if (value !== null) {
                if (value.length === 9) {
                    if (/^\d+$/.test(value)) {
                        retValue = value.slice(0, 5) + '-' + value.slice(5);
                    }
                }
            }
        }
        return retValue;
    }
    const handleFormSubmission = async () => {
        // newFormData = { ...formData, ZipCode: handle9DigitZips(formData.ZipCode) }; 
        const fieldsAreUnanimouslyValid = validationGroupRef.current?.instance.validate().isValid;
        if (isNotDirty === true) {
            showNotification(
                'One or more fields must be updated in order to save form. Please review your form and try again.',
                false,
                5000,
                500
            );

            return;
        };

        if (fieldsAreUnanimouslyValid === false) {
            showNotification(
                'Unable to save record. One or more required fields are invalid. Please review each field that needs correcting and try again',
                false,
                5000,
                500
            );
        };

        if (fieldsAreUnanimouslyValid === true) {
            setIsLoading(true);

            try {
                const { Errors, Success } = await PutPostPatchFetch(
                    '/v1/Building/updateBuilding',
                    'PUT',
                    {
                        'SequenceNumber': formData.BuildingNumber,
                        'Name': formData.name,
                        'Status': formData.status,
                        'Facility': formData.facility,
                        'RegionNumber': formData.region,
                        'BuildingId': formData.BuildingId,
                        'Location': {
                            'Id': formData.locationId,
                            'Address1': formData.AddressOne,
                            'Address2': formData.AddressTwo,
                            'CityName': formData.CityName,
                            'State': formData.State,
                            'ZipCode': formData.ZipCode
                        },
                        'RentUsageFactor': formData.rentUsageFactor,
                        'AdjustedRentSqFt': formData.adjustedRent,
                        'AdjustedUsageSqFt': formData.adjustedUsage,
                        'AnsiRentSqFt': formData.ansiRent,
                        'AnsiUsableSqFt': formData.ansiUsable,
                        'JointUseSqFt': formData.jointUse,
                        'CommunityJointUseSqFt': formData.communityJointUse,
                        'LeaseJointUseSqFt': formData.leaseJointUse,
                        'CongressionalRep': formData.congressionalRep,
                        'Version': formData.version
                    }
                );

                if (Success) {
                    showNotification(
                        `Building ${formData.BuildingNumber} was saved, successfully.`,
                        true,
                        4000,
                        500
                    );
                    navigate(ROUTE_REGION_AND_BUILDING_DATA.withSlash);
                };

                if (Errors.length > 0) {
                    showNotification(
                        `Building ${formData.BuildingNumber} was not successful in saving.\nReason: ${save.Errors[0].Message}`,
                        true,
                        3000,
                        500
                    );
                };

                setIsLoading(false);

            }
            catch (error) {
                return;
            }
        };
    };

    const childProps = {
        buttonConfiguration: [
            {
                buttonType: 'Back',
                label: 'Cancel',
                onClick: () => navigate(ROUTE_REGION_AND_BUILDING_DATA.withSlash),
                type: 'default',
                variant: 'outlined'
            },
            {
                buttonType: 'Save',
                label: 'Save',
                onClick: handleFormSubmission,
                type: 'default',
                variant: 'contained'
            },
        ],
        formConfiguation: { columnCount: 24 },
        formFieldsConfiguration: [
            {
                colSpan: 4,
                fieldType: buttonTypeNames.textBox,
                formGroupName: formGroupNames.administrative,
                label: 'Building Number',
                maxLength: 6,
                onValueChanged: ({ value }) => setFormData({ ...formData, BuildingNumber: value.toUpperCase() }),
                pattern: /^(?:\d{4}[A-Z]{2}|[A-Z]{2}\d{4})$/,
                patternMessage: 'Building Number format must be AA9999 or 9999AA',
                patternRequired: true,
                readOnly: true,
                requiredRule: true,
                requiredRuleMessage: 'Building Number is required',
                stringLengthMinimum: 6,
                stringLengthMaximum: 6,
                stringLengthMessage: 'Building Number must be exactly six (6) characters',
                stringLengthRequired: true,
                value: formData.BuildingNumber
            },
            {
                colSpan: 4,
                fieldType: buttonTypeNames.textBox,
                formGroupName: formGroupNames.administrative,
                label: 'Name',
                onValueChanged: ({ value }) => {
                    newFormData = { ...formData, name: value };
                    setFormData(newFormData);
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                requiredRule: true,
                requiredRuleMessage: 'Name is required',
                value: formData.name
            },
            {
                colSpan: 3,
                fieldType: buttonTypeNames.selectBox,
                formGroupName: formGroupNames.administrative,
                label: 'Status',
                onValueChanged: ({ value }) => {
                    newFormData = { ...formData, status: value };
                    setFormData(newFormData);
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                options: [
                    'Active',
                    'Inactive'
                ],
                value: formData.status,
            },
            {
                colSpan: 3,
                fieldType: buttonTypeNames.textBox,
                formGroupName: formGroupNames.administrative,
                label: 'Facility',
                onValueChanged: ({ value }) => {
                    newFormData = { ...formData, facility: value };
                    setFormData(newFormData);
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                requiredRule: true,
                maxLength: 4,
                requiredRuleMessage: 'Facility is required',
                value: formData.facility
            },
            {
                colSpan: 5,
                fieldType: buttonTypeNames.textBox,
                formGroupName: formGroupNames.address,
                label: 'Address One',
                onValueChanged: ({ value }) => {
                    newFormData = { ...formData, AddressOne: value };
                    setFormData(newFormData);
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                requiredRule: true,
                requiredRuleMessage: 'Address One is required',
                value: formData.AddressOne
            },
            {
                colSpan: 5,
                fieldType: buttonTypeNames.textBox,
                formGroupName: formGroupNames.address,
                label: 'Address Two',
                onValueChanged: ({ value }) => {
                    newFormData = { ...formData, AddressTwo: value };
                    setFormData({ ...formData, AddressTwo: value });
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                value: formData.AddressTwo
            },
            {
                colSpan: 4,
                fieldType: buttonTypeNames.textBox,
                formGroupName: formGroupNames.address,
                label: 'City',
                onValueChanged: ({ value }) => {
                    newFormData = { ...formData, CityName: value };
                    setFormData(newFormData);
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                requiredRule: true,
                requiredRuleMessage: 'City name is required',
                value: formData.CityName
            },
            {
                colSpan: 3,
                fieldType: buttonTypeNames.selectBox,
                formGroupName: formGroupNames.address,
                label: 'State',
                onValueChanged: ({ value }) => {
                    newFormData = { ...formData, State: value };
                    setFormData(newFormData);
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                options: [...usStates].map(({ value }) => value),
                requiredRule: true,
                value: formData.State
            },
            {
                colSpan: 4,
                fieldType: buttonTypeNames.textBox,
                formGroupName: formGroupNames.address,
                label: 'Zip Code',
                maxLength: 10,
                onValueChanged: ({ value }) => {
                    let retValue = handle9DigitZips(value);
                    newFormData = { ...formData, ZipCode: retValue };
                    setFormData(newFormData);
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                requiredRule: true,
                requiredRuleMessage: 'Zip code is required',
                pattern: /^\d{5}(?:-\d{4})?$/,
                patternMessage: `Zip Code must be either five (5) numbers or (9) numbers and must be formatted as 00000 or 00000-0000`,
                patternRequired: true,
                value: formData.ZipCode
            },
            {
                colSpan: 3,
                fieldType: buttonTypeNames.selectBox,
                formGroupName: formGroupNames.administrative,
                label: 'Region',
                onValueChanged: ({ value }) => {
                    newFormData = { ...formData, region: value };
                    setFormData(newFormData);
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                options: regions,
                requiredRule: true,
                requiredRuleMessage: 'Region is required',
                value: formData.region
            },
            {
                colSpan: 5,
                fieldType: buttonTypeNames.textBox,
                formGroupName: formGroupNames.administrative,
                label: 'Congressional Representative',
                onValueChanged: ({ value }) => {
                    newFormData = { ...formData, congressionalRep: value };
                    setFormData(newFormData);
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                value: formData.congressionalRep
            },
            {
                colSpan: 5,
                fieldType: buttonTypeNames.numberBox,
                formGroupName: formGroupNames.costs,
                label: 'Rent Usage Factor',
                onValueChanged: ({ value }) => {
                    newData = { ...formData, rentUsageFactor: value };
                    setFormData(newData);
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                value: formData.rentUsageFactor
            },
            {
                colSpan: 6,
                fieldType: buttonTypeNames.numberBox,
                formGroupName: formGroupNames.costs,
                label: 'Adjusted Rent Sq. Ft.',
                onValueChanged: ({ value }) => {
                    setFormData({ ...formData, adjustedRent: value });
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                value: formData.adjustedRent
            },
            {
                colSpan: 6,
                fieldType: buttonTypeNames.numberBox,
                formGroupName: formGroupNames.costs,
                label: 'Adjusted Usage Sq. Ft.',
                onValueChanged: ({ value }) => {
                    setFormData({ ...formData, adjustedUsage: value });
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                value: formData.adjustedUsage
            },
            {
                colSpan: 6,
                fieldType: buttonTypeNames.numberBox,
                formGroupName: formGroupNames.costs,
                label: 'Ansi Rent Sq. Ft.',
                onValueChanged: ({ value }) => {
                    setFormData({ ...formData, ansiRent: value });
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                value: formData.ansiRent
            },
            {
                colSpan: 6,
                fieldType: buttonTypeNames.numberBox,
                formGroupName: formGroupNames.costs,
                label: 'Ansi Usable Sq. Ft.',
                onValueChanged: ({ value }) => {
                    setFormData({ ...formData, ansiUsable: value });
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                value: formData.ansiUsable
            },
            {
                colSpan: 6,
                fieldType: buttonTypeNames.numberBox,
                formGroupName: formGroupNames.costs,
                label: 'Joint Use Sq. Ft.',
                onValueChanged: ({ value }) => {
                    setFormData({ ...formData, jointUse: value })
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                value: formData.jointUse
            },
            {
                colSpan: 6,
                fieldType: buttonTypeNames.numberBox,
                formGroupName: formGroupNames.costs,
                label: 'Communnity Joint Use Sq. Ft.',
                onValueChanged: ({ value }) => {
                    setFormData({ ...formData, communityJointUse: value });
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                value: formData.communityJointUse
            },
            {
                colSpan: 6,
                fieldType: buttonTypeNames.numberBox,
                formGroupName: formGroupNames.costs,
                label: 'Lease Joint Use Sq. Ft.',
                onValueChanged: ({ value }) => {
                    setFormData({ ...formData, leaseJointUse: value });
                    setIsNotDirty(isFormDirty(newFormData, initialFormDataRef.current));
                },
                value: formData.leaseJointUse
            }
        ],
        headingTwo: 'Select a field to update, then click "Save".',
        isLoading,
        loadingMessage: 'Saving...',
        title: `${title}: ${formData.BuildingNumber}`,
        validationGroupRef: validationGroupRef
    };

    return <FormConfig {...childProps} />

};

export default BuildingsUpdate;